import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Title, Fieldset } from "rbx";

import TariffRateForm from "./TariffRateForm";
import {
  UPDATE_TARIFF_RATE_MUTATION,
  DELETE_TARIFF_RATE_MUTATION
} from "../../graphql/Tariffs/Tariffs.graphql";
import { ourToast as toast } from "../../utils";

import { EditFormButtonGroup } from "../inputs";

const INITIAL_STATE = {
  MaxMiles: "",
  Rate: ""
};

function EditTariffRateForm({ tariffRate, onComplete }) {
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE,
    ...tariffRate
  });
  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const [updateTariffRate, { loading }] = useMutation(
    UPDATE_TARIFF_RATE_MUTATION,
    {
      refetchQueries: ["ALL_TARIFF_RATES_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      await updateTariffRate({
        variables: {
          data: {
            TariffRecIdRef: parseInt(tariffRate.TariffRecIdRef),
            MaxMiles: parseInt(inputs.MaxMiles),
            Rate: parseFloat(inputs.Rate)
          },
          where: {
            RecId: parseInt(tariffRate.RecId)
          }
        }
      });
      toast.success("Tariff Rate added successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error adding Tariff Rate.");
    }
  };
  return (
    <div className="edit-tariff-rate-form">
      <Title>Edit Tariff Rate</Title>
      <form id="edit-tariff-rate-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <TariffRateForm inputs={inputs} onChange={handleChange} />
          <hr />
          <EditFormButtonGroup
            deleteMutation={DELETE_TARIFF_RATE_MUTATION}
            form="edit-tariff-rate-form"
            refetchQueries={["ALL_TARIFF_RATES_QUERY"]}
            variables={{ where: { RecId: parseInt(tariffRate.RecId) } }}
            onComplete={onComplete}
          />
        </Fieldset>
      </form>
    </div>
  );
}

EditTariffRateForm.propTypes = {
  onComplete: PropTypes.func,
  tariffRate: PropTypes.object
};

export default EditTariffRateForm;
